/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  Paper,
  TextField,
  Typography,
  Divider,
  Grid,
  Box,
  Chip,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik } from "formik";
import moment from "moment";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReplayIcon from "@mui/icons-material/Replay";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@radix-ui/react-dropdown-menu";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";

import InputText from "../../../components/form/InputText";
import InputTextDetail from "../../../components/form/InputTextDetail";
import Autocomplete from "../../../components/form/AutoComplete";
import DatePickerUi from "../../../components/form/DatePickerUi";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Question from "../../../components/form/Question";
import Table from "../../../components/form/Table";
import ItemModal from "./ItemModal";
import LogsModal from "./LogsModal";
import validator from "./validator";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getLog } from "../../../store/config/thunk/log/getAll";
import { getInvoiceClientId }          from "../../../store/transactions/thunk/invoiceClient/getId";
import { putInvoiceClient }            from "../../../store/transactions/thunk/invoiceClient/put";
import { cancelInvoiceClient }         from "../../../store/transactions/thunk/invoiceClient/cancel";
import { reprocessOdooInvoiceClient }  from "../../../store/transactions/thunk/invoiceClient/reprocessOdoo";
import { processOdooInvoiceClient }    from "../../../store/transactions/thunk/invoiceClient/processOdoo";
import { postInvoiceClientItem }   from "../../../store/transactions/thunk/invoiceClient/postItem";
import { putInvoiceClientItem }    from "../../../store/transactions/thunk/invoiceClient/putItem";
import { deleteInvoiceClientItem } from "../../../store/transactions/thunk/invoiceClient/deleteItem";
import { getClient }               from "../../../store/masters/thunk/client/getAll";

const Form = ({ setBtns }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [__] = useTranslation("invoiceClient");
  const { id } = useParams();
  const canView = useCanView();

  const [showNoti, setShowNoti] = useState({
    open: false,
    msg: "",
    variant: "error",
    action: "put",
  });
  const [alert, setAlert] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "",
  });
  const [openItem, setOpenItem] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openQuestion, setOpenQuestion] = useState({ open: false, type: "" });
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openModalLog, setOpenModalLog] = useState(false);

  const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });
  const userData = JSON.parse(localStorage.getItem("userData"));

  const invoiceType = map(userData?.invoicesTypes, ({ tipoId, description }) => ({
    value: tipoId,
    label: description,
  }));

  const divisions = map(
    userData?.divisions,
    ({ divisionId, divisionName }) => ({
      value: divisionId,
      label: divisionName,
    }),
  );

  const current        = useSelector((state) => state.transactions.invoiceClient.detail);
  const put            = useSelector((state) => state.transactions.invoiceClient.put);
  const cancel         = useSelector((state) => state.transactions.invoiceClient.cancel);
  const reprocessOdoo  = useSelector((state) => state.transactions.invoiceClient.reprocessOdoo);
  const processOdoo    = useSelector((state) => state.transactions.invoiceClient.processOdoo);
  const postItem   = useSelector((state) => state.transactions.invoiceClient.postItem);
  const putItem    = useSelector((state) => state.transactions.invoiceClient.putItem);
  const deleteItem = useSelector((state) => state.transactions.invoiceClient.deleteItem);
  const client     = useSelector((state) => state.masters.client);

  const clients = map(
    get(client, "data.data", []).filter((c) => get(c, "isActive") === "ACTIVO"),
    ({ customerId, name }) => ({ value: customerId, label: `${customerId} - ${name}` }),
  );

  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [cancelReason, setCancelReason]       = useState("");
  const detailList = get(current, "data.detalle", []);

  const statusItem = find(
    invoiceStatus,
    ({ value }) => value === get(current, "data.status"),
  );
  const currentStatus = get(statusItem, "label", "");
  const currentColor  = get(statusItem, "color", "#03BE06");

  const invoiceStatusValue = get(current, "data.status");
  const isAnulada     = invoiceStatusValue === 3;
  const isTransmitERP = invoiceStatusValue === 2;
  const isReadOnly    = isAnulada || isTransmitERP;

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>
            {map(get(err, "ValidationError", []), (item) => (
              <li>{`• ${item}`}</li>
            ))}
          </ul>
        ),
        type: "error",
        func: closeAlert,
      });
    } else {
      setAlert({
        open: true,
        type: "error",
        title: "Uno o más errores de validación han ocurrido.",
        subtitle: <li>{get(err, "ErrorMessage")}</li>,
        func: closeAlert,
      });
    }
  };

  const reload = () => {
    if (!!id) {
      dispatch(getInvoiceClientId(id));
      dispatch(getLog({ page: 1, docId: Number(id), screen: "INVOICES" }));
    }
  };

  useEffect(() => {
    if (!!id) {
      dispatch(getInvoiceClientId(id));
      dispatch(getLog({ page: 1, docId: Number(id), screen: "INVOICES" }));
      dispatch(getClient({ Export: true }));
    }
  }, [id]);

  useEffect(() => {
    if (get(put, "isSuccess", false)) {
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}));
    }
  }, [put]);

  const onSubmit = (values) => {
    if (!canView("TRANSACCIONES/INVOICES", "update")) {
      setAlert({
        open: true,
        title: "Permiso Denegado.",
        subtitle: (<ul><li>• No tienes permiso para actualizar el invoice.</li></ul>),
        type: "error",
        func: closeAlert,
      });
      return;
    }
    const body = {
      invoiceId:       Number(id),
      customerId:      get(values, "idClient"),
      fecha:           moment(get(values, "date")).format(),
      divisionId:      get(values, "division"),
      tipoInvoice:     get(values, "invoiceType"),
      anombreDe:       get(values, "aNameOf"),
      comentarios:     get(values, "comments"),
      validaSAC:       get(values, "validaSAC", false),
      motivoAnulacion: get(current, "data.motivoAnulacion", ""),
      status:          get(current, "data.status", 0),
      docSubTotal:     get(current, "data.docSubTotal", 0),
      taxTotal:        get(current, "data.taxTotal", 0),
      docTotal:        get(current, "data.docTotal", 0),
    };
    dispatch(putInvoiceClient(body));
  };

  const handleItemCallback = (itemData) => {
    const base = {
      invoiceId:       Number(id),
      comentario:      get(itemData, "comment", ""),
      cantidad:        Number(get(itemData, "quantity", 0)),
      coD_FACTURA:     get(itemData, "service"),
      descripcioN_COD: get(itemData, "serviceLabel", ""),
      cobro:           Number(get(itemData, "unitPrice", 0)),
      lineTotal:       Number(get(itemData, "priceTotal", 0)),
      lineTaxTotal:    Number(get(itemData, "priceTotal", 0)) * 0.13,
      plantelId:       Number(get(itemData, "plantel", 0)),
    };
    if (selectedItem) {
      dispatch(putInvoiceClientItem({ ...base, id: get(selectedItem, "id") }));
    } else {
      dispatch(postInvoiceClientItem(base));
    }
  };

  const handleDeleteItem = (item) => {
    setItemToDelete(item);
    setOpenQuestion({ open: true, type: "deleteItem" });
  };

  const onConfirmDelete = () => {
    dispatch(deleteInvoiceClientItem(Number(id), get(itemToDelete, "id")));
    setOpenQuestion({ open: false, type: "" });
    setItemToDelete(null);
  };

  useEffect(() => {
    if (get(postItem, "isSuccess", false) || get(putItem, "isSuccess", false)) {
      setOpenItem(false);
      setSelectedItem(null);
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(postItem, "isReject", false)) setError(get(postItem, "error", {}));
    if (get(putItem,  "isReject", false)) setError(get(putItem,  "error", {}));
    if (get(deleteItem, "isSuccess", false)) {
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "delet" });
    }
    if (get(deleteItem, "isReject", false)) setError(get(deleteItem, "error", {}));
  }, [postItem, putItem, deleteItem]);

  const onActionSubmit = (action) => {
    if (action === "reprocessOdoo") {
      dispatch(reprocessOdooInvoiceClient(id));
    } else if (action === "processOdoo") {
      dispatch(processOdooInvoiceClient(id));
    }
    setOpenQuestion({ open: false, type: "" });
  };

  const onConfirmCancel = () => {
    dispatch(cancelInvoiceClient({ documentoId: Number(id), motivoAnulacion: cancelReason }));
  };

  useEffect(() => {
    if (get(cancel, "isSuccess", false)) {
      setOpenCancelModal(false);
      setCancelReason("");
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(cancel, "isReject", false)) setError(get(cancel, "error", {}));
    if (get(reprocessOdoo, "isSuccess", false)) {
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(reprocessOdoo, "isReject", false)) setError(get(reprocessOdoo, "error", {}));
    if (get(processOdoo, "isSuccess", false)) {
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(processOdoo, "isReject", false)) setError(get(processOdoo, "error", {}));
  }, [cancel, reprocessOdoo, processOdoo]);

  const subTotal = detailList.reduce(
    (acc, item) => acc + (parseFloat(get(item, "lineTotal", 0)) || 0),
    0,
  );
  const iva = subTotal * 0.13;
  const total = subTotal + iva;

  const headDetail = [
    { key: "plantel", label: __(`tableDetail.cols.plantel`), align: "left" },
    {
      key: "quantity",
      label: __(`tableDetail.cols.quantity`),
      align: "center",
    },
    {
      key: "billingCode",
      label: __(`tableDetail.cols.billingCode`),
      align: "center",
    },
    { key: "comment", label: __(`tableDetail.cols.comment`), align: "left" },
    {
      key: "unitPrice",
      label: __(`tableDetail.cols.unitPrice`),
      align: "right",
    },
    {
      key: "amountWithoutIva",
      label: __(`tableDetail.cols.amountWithoutIva`),
      align: "right",
    },
    {
      key: "options",
      label: __(`tableDetail.cols.options`),
      align: "center",
      sx: { width: 100 },
    },
  ];

  const dataDetail = map(detailList, (row) => ({
    ...row,
    quantity:        get(row, "cantidad", "-"),
    billingCode:     get(row, "coD_FACTURA", "-"),
    comment:         get(row, "comentario", "-"),
    weight:          "-",
    pallets:         "-",
    unitPrice:       `$ ${Number(get(row, "cobro", 0)).toFixed(2)}`,
    amountWithoutIva: `$ ${Number(get(row, "lineTotal", 0)).toFixed(2)}`,
    options: (
      <Stack direction="row" spacing={0.5} justifyContent="center">
        <IconButton
          size="small"
          color="secondary"
          disabled={isReadOnly}
          onClick={() => {
            if (canView("TRANSACCIONES/INVOICES/DETALLE", "update")) {
              setSelectedItem(row);
              setOpenItem(true);
            } else {
              setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para editar líneas del invoice.</li></ul>), type: "error", func: closeAlert });
            }
          }}
        >
          <EditIcon fontSize="inherit" />
        </IconButton>
        <IconButton
          size="small"
          color="error"
          disabled={isReadOnly}
          onClick={() => {
            if (canView("TRANSACCIONES/INVOICES/DETALLE", "delete")) {
              handleDeleteItem(row);
            } else {
              setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para eliminar líneas del invoice.</li></ul>), type: "error", func: closeAlert });
            }
          }}
        >
          <DeleteIcon fontSize="inherit" />
        </IconButton>
      </Stack>
    ),
  }));

  const initialValues = {
    idClient:        get(current, "data.customerId", ""),
    date:            get(current, "data.fecha") ? moment(get(current, "data.fecha")) : new Date(),
    division:        get(current, "data.division", ""),
    invoiceType:     get(current, "data.tipoInvoice", ""),
    salesOrder:      get(current, "data.odooSOname", ""),
    aNameOf:         get(current, "data.aNombreDe", ""),
    createdBy:       get(current, "data.usuarioCreacion", ""),
    comments:        get(current, "data.comentarios", ""),
    validaSAC:       get(current, "data.validaSAC", false),
    motivoAnulacion: get(current, "data.motivoAnulacion", ""),
  };

  useEffect(() => {
    setBtns(
      <Stack
        className="mr-6"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        width="100%"
      >
        <Button
          className="w-[150px] min-w-[150px]"
          variant="outlined"
          color="secondary"
          startIcon={<HistoryIcon />}
          onClick={() => {
            if (canView("TRANSACCIONES/INVOICES/LOGS", "watch")) {
              setOpenModalLog(true);
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul><li>• No tienes permiso para ver los cambios del invoice.</li></ul>),
                type: "error",
                func: closeAlert,
              });
            }
          }}
        >
          Ver Cambios
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild disabled={isAnulada}>
            <Button
              className="w-[125px] min-w-[125px]"
              variant="outlined"
              color="secondary"
              startIcon={<MoreVertIcon />}
              disabled={isAnulada}
            >
              Acciones
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-white shadow-md rounded-md p-2 w-56 z-50">
            <DropdownMenuItem
              className="flex items-center gap-2 text-blue-800 hover:bg-blue-100 p-2 cursor-pointer"
              onClick={() => {
                if (canView("TRANSACCIONES/INVOICES/REPROCESAR", "update")) {
                  setOpenQuestion({ open: true, type: "reprocessOdoo" });
                } else {
                  setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para reprocesar a Odoo.</li></ul>), type: "error", func: closeAlert });
                }
              }}
            >
              <ReplayIcon size={16} className="text-blue-500" /> Reprocesar a
              Odoo
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex items-center gap-2 text-green-700 hover:bg-green-100 p-2 cursor-pointer"
              onClick={() => {
                if (canView("TRANSACCIONES/INVOICES/PROCESAR", "add")) {
                  setOpenQuestion({ open: true, type: "processOdoo" });
                } else {
                  setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para procesar en Odoo.</li></ul>), type: "error", func: closeAlert });
                }
              }}
            >
              <CheckCircleOutlineIcon size={16} className="text-green-500" />{" "}
              Procesar Odoo
            </DropdownMenuItem>
            <DropdownMenuItem
              className="flex items-center gap-2 text-red-600 hover:bg-red-100 p-2 cursor-pointer"
              onClick={() => {
                if (canView("TRANSACCIONES/INVOICES/ANULAR", "delete")) {
                  setCancelReason("");
                  setOpenCancelModal(true);
                } else {
                  setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para anular el invoice.</li></ul>), type: "error", func: closeAlert });
                }
              }}
            >
              <CancelOutlinedIcon size={16} className="text-red-500" /> Anular
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <LoadingButton
          className="w-[100px] min-w-[100px]"
          startIcon={<SaveIcon />}
          variant="contained"
          color="secondary"
          type="submit"
          form="form-invoice-client"
          loading={get(put, "isLoading")}
          disabled={isReadOnly}
        >
          {__(`action.save`)}
        </LoadingButton>
        <Button
          className="w-[100px] min-w-[100px]"
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/transactions/invoice-client")}
          disabled={get(put, "isLoading")}
        >
          {__(`action.cancel`)}
        </Button>
        <IconButton title="Recargar" onClick={reload}>
          <ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} />
        </IconButton>
      </Stack>,
    );
  }, [get(put, "isLoading"), invoiceStatusValue]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validator(__)}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => (
          <form id="form-invoice-client" onSubmit={get(formik, "handleSubmit")}>
            <Paper className="mt-4">
              <Stack
                className="p-4"
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography
                    component="h4"
                    variant="h4"
                  >{`${__(`labels.1`)} - ${id}`}</Typography>
                  {currentStatus && (
                    <Chip
                      label={currentStatus}
                      sx={{ bgcolor: `${currentColor}26`, color: currentColor }}
                    />
                  )}
                </Stack>
              </Stack>
              <Divider />
              <Box className="p-4">
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputTextDetail
                      formik={formik}
                      name="invoiceNumber"
                      label={__(`form.invoiceNumber.label`)}
                      placeholder={__(`form.invoiceNumber.placeholder`)}
                      disabled
                      value={get(current, "data.invoiceId", "")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <DatePickerUi
                      formik={formik}
                      name="date"
                      label={__(`form.date.label`)}
                      placeholder={__(`form.date.placeholder`)}
                      disabled={get(put, "isLoading") || isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      key={`idClient-${clients.length > 0}`}
                      name="idClient"
                      formik={formik}
                      label={__(`form.idClient.label`)}
                      placeholder={__(`form.idClient.placeholder`)}
                      options={clients}
                      disabled={!isEmpty(detailList) || get(put, "isLoading") || isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      name="division"
                      formik={formik}
                      label={__(`form.division.label`)}
                      placeholder={__(`form.division.placeholder`)}
                      options={divisions}
                      disabled={get(put, "isLoading") || isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      name="invoiceType"
                      formik={formik}
                      label={__(`form.invoiceType.label`)}
                      placeholder={__(`form.invoiceType.placeholder`)}
                      options={invoiceType}
                      disabled={get(put, "isLoading") || isReadOnly}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={3}>
                    <InputTextDetail
                      formik={formik}
                      name="status"
                      label={__(`form.status.label`)}
                      disabled
                      value={currentStatus || ""}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={3}>
                    <InputTextDetail
                      formik={formik}
                      name="salesOrder"
                      label={__(`form.salesOrder.label`)}
                      disabled
                      value={get(current, "data.odooSOname", "")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputText
                      formik={formik}
                      name="aNameOf"
                      label={__(`form.aNameOf.label`)}
                      placeholder={__(`form.aNameOf.placeholder`)}
                      disabled={get(put, "isLoading") || isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputTextDetail
                      formik={formik}
                      name="createdBy"
                      label={__(`form.createdBy.label`)}
                      disabled
                      value={get(current, "data.usuarioCreacion", "")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth>
                      <Typography className="pb-2 pl-4" component="label" color={get(put, "isLoading") || isReadOnly ? "text.lite" : "text.main"}>
                        {__(`form.validaSAC.label`)}
                      </Typography>
                      <Box sx={{ pl: 5 }}>
                        <Checkbox
                          checked={!!get(formik, "values.validaSAC")}
                          onChange={(e) => formik.setFieldValue("validaSAC", e.target.checked)}
                          disabled={get(put, "isLoading") || isReadOnly}
                          color="secondary"
                          sx={{ padding: 0 }}
                        />
                      </Box>
                    </FormControl>
                  </Grid>
                  {!!get(current, "data.motivoAnulacion") && (
                    <Grid item xs={12} sm={6} md={6}>
                      <InputTextDetail
                        formik={formik}
                        name="motivoAnulacion"
                        label={__(`form.motivoAnulacion.label`)}
                        disabled
                        value={get(current, "data.motivoAnulacion", "")}
                        multiline
                        rows={3}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Paper>

            <Paper className="mt-4">
              <Stack
                className="p-4"
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography component="h5" variant="h5">
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  size="small"
                  disabled={isReadOnly}
                  onClick={() => {
                    if (canView("TRANSACCIONES/INVOICES/DETALLE", "add")) {
                      setSelectedItem(null);
                      setOpenItem(true);
                    } else {
                      setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para agregar líneas al invoice.</li></ul>), type: "error", func: closeAlert });
                    }
                  }}
                >
                  {__(`action.add`)}
                </Button>
              </Stack>
              <Divider />
              <Table
                headTable={headDetail}
                dataTable={dataDetail}
                __={__}
                loading={get(current, "isLoading", false)}
                empty="tableDetalle"
              />
              <Divider />
              <Box className="p-4" sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <Box sx={{ flex: 1, mr: 2 }}>
                  <InputText
                    formik={formik}
                    name="comments"
                    label={__(`form.comments.label`)}
                    placeholder={__(`form.comments.placeholder`)}
                    disabled={get(put, "isLoading") || isReadOnly}
                    multiline
                    rows={3}
                  />
                </Box>
                <Box sx={{ minWidth: 240 }}>
                  <Stack direction="row" justifyContent="space-between" spacing={4}>
                    <Typography variant="body2" fontWeight="bold">Sub Total:</Typography>
                    <Typography variant="body2">$ {subTotal.toFixed(2)}</Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={4}>
                    <Typography variant="body2" fontWeight="bold">IVA:</Typography>
                    <Typography variant="body2">$ {iva.toFixed(2)}</Typography>
                  </Stack>
                  <Divider sx={{ my: 0.5 }} />
                  <Stack direction="row" justifyContent="space-between" spacing={4}>
                    <Typography variant="body1" fontWeight="bold">Total:</Typography>
                    <Typography variant="body1" fontWeight="bold">$ {total.toFixed(2)}</Typography>
                  </Stack>
                </Box>
                <Box sx={{ width: 84, minWidth: 84, flexShrink: 0 }} />
              </Box>
            </Paper>
          </form>
        )}
      </Formik>

      <Dialog open={openCancelModal} onClose={() => setOpenCancelModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{__(`alert.cancel.title`)}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>{__(`alert.cancel.detail`)}</Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={3}
            label="Motivo de anulación"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCancelModal(false)} color="secondary" variant="outlined">
            {__(`action.cancel`)}
          </Button>
          <LoadingButton
            onClick={onConfirmCancel}
            color="error"
            variant="contained"
            loading={get(cancel, "isLoading", false)}
            disabled={!cancelReason.trim()}
          >
            Anular
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <LogsModal
        __={__}
        open={openModalLog}
        close={() => setOpenModalLog(false)}
      />
      <ItemModal
        open={openItem}
        close={() => {
          setOpenItem(false);
          setSelectedItem(null);
        }}
        callback={handleItemCallback}
        __={__}
        item={selectedItem}
        isLoading={get(postItem, "isLoading", false) || get(putItem, "isLoading", false)}
      />

      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Question
        title={__(`alert.${get(openQuestion, "type", "deleteItem")}.title`)}
        detail={__(`alert.${get(openQuestion, "type", "deleteItem")}.detail`)}
        onSuccess={() => {
          const type = get(openQuestion, "type");
          if (type === "deleteItem") {
            onConfirmDelete();
          } else {
            onActionSubmit(type);
          }
        }}
        onCancel={() => setOpenQuestion({ open: false, type: "" })}
        open={get(openQuestion, "open", false)}
      />
    </div>
  );
};

export default Form;
